import GeneralConfig from 'services/metaData/generalConfig';

let DSI_2_PORT = '';
const generalConfigs = GeneralConfig();
if (!generalConfigs.isProduction
    && (generalConfigs.domain === '//local.supersonicads.com')
    && generalConfigs.demandPlatformPort) {
    DSI_2_PORT = `:${generalConfigs.demandPlatformPort}`;
}
const DSI_2_URL = `//${generalConfigs.domain + DSI_2_PORT}/demand`;

class DemandConfig {
    dsi2LoginAsQueryParam = '';

    setLoginAs(userName) {
        this.dsi2LoginAsQueryParam = `?loginAs=${userName}`;
    }

    clearLoginAs() {
        this.dsi2LoginAsQueryParam = '';
    }

    getPathUrl(path) {
        return DSI_2_URL + path + this.dsi2LoginAsQueryParam;
    }

    redirectTo(path) {
        window.location.href = DSI_2_URL + path + this.dsi2LoginAsQueryParam;
    }
}

export default new DemandConfig();
